var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 19",
    style: {
      enableBackground: "new 0 0 19 19"
    },
    color: "#60657A",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M5.5,0.8h8c2.6,0,4.8,2.1,4.8,4.8v8c0,2.6-2.1,4.8-4.8,4.8h-8c-2.6,0-4.8-2.1-4.8-4.8v-8 C0.8,2.9,2.9,0.8,5.5,0.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.3,13.3C6.3,13.7,6,14,5.7,14C5.3,14,5,13.7,5,13.3V5.7C5,5.3,5.3,5,5.7,5C6,5,6.3,5.3,6.3,5.7V13.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.3,9.1l-3.2-3C10,6,9.8,5.9,9.7,5.9C9.5,5.9,9.3,6,9.2,6.1S9,6.4,9,6.5c0,0.2,0.1,0.3,0.2,0.4L12,9.5 l-2.7,2.6c-0.1,0.1-0.1,0.1-0.1,0.2C9,12.3,9,12.4,9,12.5c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.1,0.1,0.2C9.3,13,9.3,13,9.4,13 c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1l3.2-3c0.1-0.1,0.2-0.3,0.2-0.4C13.5,9.3,13.4,9.2,13.3,9.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.a29f49bf31fbf2ce91bfe2fa3ae7ad4c.svg";
export { ForwardRef as ReactComponent };